(function () {
  function initShowcase(root) {
    (root || document).querySelectorAll('[data-chakrikka-showcase]').forEach(function (showcase) {
      if (showcase.dataset.showcaseInitialized === 'true') return;
      showcase.dataset.showcaseInitialized = 'true';

      var frame = showcase.querySelector('[data-showcase-frame]');
      var mediaHoverRoot = showcase.querySelector('[data-showcase-autoplay-hover]');
      var slides = Array.prototype.slice.call(showcase.querySelectorAll('[data-showcase-slide]'));
      var navButtons = Array.prototype.slice.call(showcase.querySelectorAll('[data-showcase-dot-button]'));
      var floaters = Array.prototype.slice.call(showcase.querySelectorAll('[data-showcase-floater]'));
      var autoplayMs = Number(showcase.dataset.autoplayMs || 10000);
      var currentIndex = Math.max(
        0,
        slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        })
      );
      var autoplayTimer = null;

      if (!slides.length) return;

      function clearAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function closeTooltips() {
        floaters.forEach(function (floater) {
          floater.classList.remove('is-tooltip-open');
        });
      }

      function syncHeight() {
        if (!frame) return;

        var maxHeight = 0;
        slides.forEach(function (slide) {
          maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });

        frame.style.minHeight = maxHeight ? maxHeight + 'px' : '';
      }

      function restartProgress(index) {
        var button = navButtons[index];
        if (!button) return;

        var progress = button.querySelector('[data-showcase-progress]');
        if (!progress) return;

        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = '';
      }

      /** Remaining ms on the active dot’s progress animation (for resume after hover pause). */
      function getActiveProgressRemainingMs() {
        var button = navButtons[currentIndex];
        if (!button) return null;
        var progress = button.querySelector('[data-showcase-progress]');
        if (!progress || typeof progress.getAnimations !== 'function') return null;
        try {
          var anims = progress.getAnimations();
          if (!anims.length) return null;
          var anim = anims[0];
          var effect = anim.effect;
          if (!effect || typeof effect.getTiming !== 'function') return null;
          var duration = effect.getTiming().duration;
          if (typeof duration !== 'number' || !isFinite(duration) || duration <= 0) return null;
          var currentTime = anim.currentTime;
          if (typeof currentTime !== 'number' || !isFinite(currentTime)) currentTime = 0;
          return Math.max(0, duration - currentTime);
        } catch (e) {
          return null;
        }
      }

      function setActive(index) {
        currentIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        navButtons.forEach(function (button, buttonIndex) {
          var isActive = buttonIndex === currentIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        floaters.forEach(function (floater, floaterIndex) {
          floater.classList.toggle('is-active', floaterIndex === currentIndex);
        });

        window.requestAnimationFrame(syncHeight);
      }

      function startAutoplay(resumeProgress) {
        clearAutoplay();

        if (slides.length <= 1) {
          showcase.classList.remove('is-paused');
          return;
        }

        if (!resumeProgress) {
          showcase.classList.remove('is-paused');
          restartProgress(currentIndex);
          autoplayTimer = window.setInterval(function () {
            setActive(currentIndex + 1);
            restartProgress(currentIndex);
          }, autoplayMs);
          return;
        }

        var remaining = getActiveProgressRemainingMs();
        showcase.classList.remove('is-paused');

        if (remaining === null) {
          restartProgress(currentIndex);
          autoplayTimer = window.setInterval(function () {
            setActive(currentIndex + 1);
            restartProgress(currentIndex);
          }, autoplayMs);
          return;
        }

        autoplayTimer = window.setTimeout(function () {
          setActive(currentIndex + 1);
          restartProgress(currentIndex);
          autoplayTimer = window.setInterval(function () {
            setActive(currentIndex + 1);
            restartProgress(currentIndex);
          }, autoplayMs);
        }, remaining);
      }

      function pauseAutoplay() {
        showcase.classList.add('is-paused');
        clearAutoplay();
      }

      setActive(currentIndex);
      startAutoplay();

      navButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setActive(Number(button.dataset.showcaseIndex || 0));
          startAutoplay();
        });
      });

      floaters.forEach(function (floater) {
        var floaterIndex = Number(floater.dataset.showcaseIndex || 0);

        floater.addEventListener('pointerenter', function () {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            setActive(floaterIndex);
          }
        });

        floater.addEventListener('focus', function () {
          setActive(floaterIndex);
        });

        floater.addEventListener('click', function (event) {
          var hasTooltip = floater.dataset.tooltipEnabled === 'true';

          setActive(floaterIndex);
          startAutoplay();

          if (hasTooltip && !floater.classList.contains('is-tooltip-open')) {
            event.preventDefault();
            event.stopPropagation();
            closeTooltips();
            floater.classList.add('is-tooltip-open');
          }
        });
      });

      if (mediaHoverRoot) {
        mediaHoverRoot.addEventListener('pointerenter', pauseAutoplay);
        mediaHoverRoot.addEventListener('pointerleave', function () {
          startAutoplay(true);
        });
      }

      window.addEventListener('resize', syncHeight);
      window.addEventListener('load', syncHeight, { once: true });

      document.addEventListener('pointerdown', function (event) {
        if (!showcase.contains(event.target)) {
          closeTooltips();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initShowcase(document);
    });
  } else {
    initShowcase(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initShowcase(event.target);
  });
})();
